import BaseFile from '@/modules/common/models/file/base-file.ts';
import { DateTime } from 'luxon';
import { useSyncSystemStore } from '@/modules/core/stores/sync-system.store.ts';
import type UploadFile from '@/modules/common/models/file/upload-file.ts';
import type { ApiFileDto } from '@/modules/document/dto/api-file.dto.ts';
import type { SQLDate } from '@/modules/common/types/sql-date.type.ts';
import { LuxonUtil } from '@/modules/common/utils/luxon.util.ts';
import i18n from '@/i18n.ts';

export default class ApiFile extends BaseFile {
  fileId: number;
  userId: number;
  hash: string;
  url: string;
  pdfUrl: string;
  comment: string | null;
  revision: number;
  createdAt: SQLDate;
  createdDate: string;
  size: number;
  storedName: string;
  storedComment: string | null;
  uploadedName: string;

  constructor(response: ApiFileDto, file?: UploadFile, uploadedName?: string) {
    super(file?.id || response['F_ID'], file?.name || response['Название'], file?.size || response['Размер']);

    const syncSystemStore = useSyncSystemStore();

    this.fileId = response['F_ID'];
    this.userId = response['LOGIN_ID'];
    this.hash = response['Файл'];
    this.url = `${syncSystemStore.storageUrl}${this.hash}.${this.extension}`;
    this.pdfUrl = `${syncSystemStore.storageUrl}${this.hash}.${this.type === 'pdf' ? this.extension : 'pdf'}`;
    this.comment = file?.comment ?? response['Примечание'] ?? null;
    this.revision = response['Редакция'];
    this.createdAt = response['Создан'];
    this.createdDate = this.getCreatedDate(response['Создан']);
    this.size = file?.size || response['Размер'];
    this.storedName = response['Название'];
    this.uploadedName = uploadedName ?? response['Название'];
    this.storedComment = response['Примечание'] ?? null;

    if (file) {
      this.renamed = file.renamed;
      this.commented = file.commented;
      this.systemPrefix = file.systemPrefix;
      this.prefixAutoStripped = file.prefixAutoStripped;
    }
  }

  get unsaved(): boolean {
    return this.name !== this.uploadedName || this.comment !== this.storedComment;
  }

  get nameToSave(): string {
    return this.name === this.uploadedName ? this.storedName : this.name;
  }

  private getCreatedDate(date: string) {
    return LuxonUtil.formatSQL(date, i18n.global.locale.value, DateTime.DATETIME_SHORT) ?? '';
  }
}
